/* eslint-disable no-new */

import Vue from 'vue';

import inject from './VueInstanceInject';
import './stylus/main.styl';

import './Config';
import './plugins';
import './filters';

import App from './App';

import './components/widgets/index';

Vue.config.productionTip = false;

// Caso precise injetar algo na instancia root do Vue
// utilize o arquivo @/vue-instance-inject
new Vue({
  el: '#app',
  ...inject,
  template: '<v-app><App/></v-app>',
  components: { App },
});

// eslint-disable-next-line
import './interceptors';



// WEBPACK FOOTER //
// ./src/Main.js